export default "__VITE_ASSET__KwUW$sqg__"